// Plugin docs: http://kenwheeler.github.io/slick/

(function ($) {

	$.fn.carousel = function() {

		var elem = $(this),
			parent = elem.find('.js-carousel__parent'),
			buttons = elem.find('.js-carousel__button'),
			settings = {
				itemSelector: '.js-carousel__item',
				innerContentSelector: '.js-carousel__inner__content',
				loadedClass: 'is-loaded',
				largeBreakpointHiddenClass: 'is-desk-hidden',
				largeBreakpointLimitedItemsModifier: 'carousel--desk-limited-items',
				largeBreakpointMinItems: 4,
				pluginOptions: {
					arrows: false,
					slidesToShow: 3,
					infinite: true,
					responsive: [
						{
							breakpoint: 999,
							settings: {
								slidesToShow: 2
							}
						},
						{
							breakpoint: 683,
							settings: {
								slidesToShow: 1,
								adaptiveHeight: true
							}
						}
					]
				}
			};

		var init = function() {

			// Load items for checks
			var items = elem.find(settings.itemSelector);

			// Check that there's a minimum of X items at the large breakpoint
			if(items.length < settings.largeBreakpointMinItems) {
				elem.addClass(settings.largeBreakpointLimitedItemsModifier);
				buttons.addClass(settings.largeBreakpointHiddenClass);
			}
			else {
				elem.removeClass(settings.largeBreakpointLimitedItemsModifier);
				buttons.removeClass(settings.largeBreakpointHiddenClass);
			}

			// Attach slick plugin
			parent.slick(settings.pluginOptions);

			setTimeout(function() {

				if($.getBreakpoint() !== 'palm') {

					// Level each item's height
					parent.levelHeights({
						selector: settings.itemSelector
					});

					// Level inner content heights
					parent.levelHeights({
						selector: settings.innerContentSelector
					});

				}

				// Add loaded class to elem so it can show
				elem.addClass(settings.loadedClass);

			}, 500);

			// On left and right button click
			buttons.off('click').on('click', function(evt) {

				evt.preventDefault();

				var button = $(this);

				// return if disabled
				if(button.hasClass('is-disabled') || button.is(':disabled')) {
					return;
				}

				// Fire api method based on direction
				switch(button.attr('data-direction')) {
					case 'next':
					default:
						parent.slick('slickNext');
						break;
					case 'prev':
						parent.slick('slickPrev');
						break;
				}
			});

		};

		init();
		return this;
	};

}($));
